import { Navigate } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { hasPermission } from "@itaas/core/rbac/access";
import { TENANT_ADMIN_MENU_ITEMS } from "@itaas/core/admin/navigation/admin-menu.config";
import { openTenantAdminPage } from "@itaas/core/admin/tenant-admin-navigation";
import { getModuleBaseUrl } from "@/config";
import { canAccessPlatformUsers } from "@/navigation/platform-access";
import { routes } from "@/router/all_routes";

const MENU_LABELS: Record<string, string> = {
  "menu.item.tenantUsers": "Utilisateurs",
  "menu.item.tenantRoles": "Rôles",
  "menu.item.tenantModuleAccess": "Accès modules",
  "menu.item.tenantSites": "Sites",
  "menu.item.tenantProvisioning": "Provisionnement",
  "menu.item.invitations": "Invitations",
};

function canOpenMenuItem(
  user: ReturnType<typeof useAuth>["user"],
  item: (typeof TENANT_ADMIN_MENU_ITEMS)[number],
): boolean {
  if (!user) return false;
  if (user.isSuperAdmin) return true;
  if (item.permissions?.length) {
    return item.permissions.some((perm) => hasPermission(user, perm));
  }
  return true;
}

export function PlatformUsersHubPage() {
  const { user } = useAuth();
  const rhBaseUrl = getModuleBaseUrl("rh");

  if (!canAccessPlatformUsers(user)) {
    return <Navigate to={routes.accessDenied} replace />;
  }

  const items = TENANT_ADMIN_MENU_ITEMS.filter((item) => canOpenMenuItem(user, item));

  return (
    <div className="suite-platform-page">
      <header className="suite-platform-page__header">
        <div>
          <h1 className="h4 mb-1">Utilisateurs & rôles</h1>
          <p className="text-muted small mb-0">
            Administration IAM de votre organisation — ouverture sécurisée via le module RH.
          </p>
        </div>
      </header>

      <div className="row g-3">
        {items.map((item) => (
          <div className="col-md-6 col-lg-4" key={item.id}>
            <button
              type="button"
              className="suite-platform-card-btn"
              onClick={() => openTenantAdminPage(rhBaseUrl, item.path)}
            >
              <span className="suite-platform-card-btn__title">
                {MENU_LABELS[item.labelKey] ?? item.id}
              </span>
              <span className="suite-platform-card-btn__path">{item.path}</span>
            </button>
          </div>
        ))}
      </div>

      <p className="small text-muted mt-4 mb-0">
        Les écrans détaillés restent hébergés par le module RH le temps de la migration complète
        vers Suite. Le handoff SSO est inchangé.
      </p>
    </div>
  );
}
